import React from 'react';
import { ProjectsFooter } from './ProjectsFooter';

export const Footer: React.FC = () => {
  return <ProjectsFooter />;
};
